import { render, staticRenderFns } from "./TagFeatureText.vue?vue&type=template&id=4a956345&scoped=true"
import script from "./TagFeatureText.vue?vue&type=script&lang=js"
export * from "./TagFeatureText.vue?vue&type=script&lang=js"
import style0 from "./TagFeatureText.vue?vue&type=style&index=0&id=4a956345&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a956345",
  null
  
)

export default component.exports